import React from 'react'
import { Grid } from '@mui/material'

import GroupingExportModalTable from 'Pages/ReportsAlerts/ExportsGrouping/Modal/Table'


export default function GroupingExportsModalContent() {

	return <Grid container spacing={2}>
		<Grid item xs={12}>
			<GroupingExportModalTable/>
		</Grid>
	</Grid>

}